// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__kgXrb","table":"Table_table__5-7s2","row":"Table_row__tshZh","col":"Table_col__LiTIU"};